import { GetHelpDrawer } from 'reservations/account/components/GetHelpDrawer';
import { BaseDrawerContainer } from 'reservations/base/components/BaseDrawerContainer';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { CancelReservationModal } from 'reservations/cancel/components/CancelReservationModal';
import AddCardModal from 'reservations/checklessPayments/components/AddCardModal';
import { AddCardToEnrollModal } from 'reservations/checklessPayments/components/AddCardToEnrollModal';
import { AddCardToSplitGuestModal } from 'reservations/checklessPayments/components/AddCardToSplitGuestModal';
import { AddCardToSplitLeadModal } from 'reservations/checklessPayments/components/AddCardToSplitLeadModal';
import AddTipModal from 'reservations/checklessPayments/components/AddTipModal';
import EditCardModal from 'reservations/checklessPayments/components/EditCardModal';
import EnrollmentCompleteModal from 'reservations/checklessPayments/components/EnrollmentCompleteModal';
import { InviteToSplitModal } from 'reservations/checklessPayments/components/InviteToSplitModal';
import { ManageSplitBillModal } from 'reservations/checklessPayments/components/ManageSplitBillModal';
import OtpModal from 'reservations/checklessPayments/components/OtpModal';
import RemoveCardModal from 'reservations/checklessPayments/components/RemoveCardModal';
import { RemoveCardModalV2 } from 'reservations/checklessPayments/components/RemoveCardModalV2';
import ReviewUnsavedCardModal from 'reservations/checklessPayments/components/ReviewUnsavedCardModal';
import SelectCardModal from 'reservations/checklessPayments/components/SelectCardModal';
import { SelectGratuityModal } from 'reservations/checklessPayments/components/SelectGratuityModal';
import UpdateCardModal from 'reservations/checklessPayments/components/UpdateCardModal';
import { UpdateCardModalV2 } from 'reservations/checklessPayments/components/UpdateCardModalV2';
import UpdateTipModal from 'reservations/checklessPayments/components/UpdateTipModal';
import { ViewSplitBillModal } from 'reservations/checklessPayments/components/ViewSplitBillModal';
import { ConfirmReservationModal } from 'reservations/confirmation/components/ConfirmReservationModal';
import { BookingFormModal } from 'reservations/form/components/BookingFormModal';
import { LeavePartyModal } from 'reservations/guests/components/LeavePartyModal';
import { ManageGuestsModal } from 'reservations/guests/components/ManageGuestsModal';
import { ModifyGuestsModal } from 'reservations/guests/components/ModifyGuestsModal';
import { RemoveGuestModal } from 'reservations/guests/components/RemoveGuestModal';
import { ViewGuestsModal } from 'reservations/guests/components/ViewGuestsModal';
import { AddToCalendarModal } from 'reservations/preDining/components/AddToCalendarModal';
import { ManageReservationModal } from 'reservations/preDining/components/ManageReservationModal';
import { SpecialOccasionModal } from 'reservations/preDining/components/SpecialOccasionModal';
import { SpecialRequestModal } from 'reservations/preDining/components/SpecialRequestModal';
import { LeaveWaitlistModal } from 'reservations/waitlist/components/LeaveWaitlistModal';
import { WaitlistEstimateModal } from 'reservations/waitlist/components/WaitlistEstimateModal';

interface ModalComponentMapEntry {
  ModalComponent: React.ComponentType<any>;
  wrapInContainer?: boolean;
}

export const MODAL_COMPONENT_MAP: Record<ModalType, ModalComponentMapEntry> = {
  [ModalType.AddCardToEnroll]: {
    ModalComponent: AddCardToEnrollModal
  },
  [ModalType.AddCardToSplitGuest]: {
    ModalComponent: AddCardToSplitGuestModal
  },
  [ModalType.AddCardToSplitLead]: {
    ModalComponent: AddCardToSplitLeadModal
  },
  [ModalType.AddToCalendar]: {
    ModalComponent: AddToCalendarModal
  },
  [ModalType.BookingFields]: {
    ModalComponent: BookingFormModal
  },
  [ModalType.CancelReservation]: {
    ModalComponent: CancelReservationModal
  },
  [ModalType.ChecklessAddCard]: {
    ModalComponent: AddCardModal
  },
  [ModalType.ChecklessAddTip]: {
    ModalComponent: AddTipModal
  },
  [ModalType.ChecklessEnrollmentComplete]: {
    ModalComponent: EnrollmentCompleteModal
  },
  [ModalType.ChecklessEditCard]: {
    ModalComponent: EditCardModal
  },
  [ModalType.ChecklessOtp]: {
    ModalComponent: OtpModal
  },
  [ModalType.ChecklessRemoveCard]: {
    ModalComponent: RemoveCardModal
  },
  [ModalType.ChecklessReviewUnsavedCard]: {
    ModalComponent: ReviewUnsavedCardModal
  },
  [ModalType.ChecklessSelectCard]: {
    ModalComponent: SelectCardModal
  },
  [ModalType.ChecklessUpdateCard]: {
    ModalComponent: UpdateCardModal
  },
  [ModalType.ChecklessUpdateTip]: {
    ModalComponent: UpdateTipModal
  },
  [ModalType.ConfirmReservation]: {
    ModalComponent: ConfirmReservationModal
  },
  [ModalType.GetHelp]: {
    ModalComponent: GetHelpDrawer,
    wrapInContainer: false
  },
  [ModalType.InviteToSplit]: {
    ModalComponent: InviteToSplitModal
  },
  [ModalType.LeaveParty]: {
    ModalComponent: LeavePartyModal
  },
  [ModalType.LeaveWaitlist]: {
    ModalComponent: LeaveWaitlistModal
  },
  [ModalType.ManageGuests]: {
    ModalComponent: ManageGuestsModal
  },
  [ModalType.ManageReservation]: {
    ModalComponent: ManageReservationModal
  },
  [ModalType.ManageSplitBill]: {
    ModalComponent: ManageSplitBillModal
  },
  [ModalType.ModifyGuests]: {
    ModalComponent: ModifyGuestsModal
  },
  [ModalType.RemoveCard]: {
    ModalComponent: RemoveCardModalV2
  },
  [ModalType.RemoveGuest]: {
    ModalComponent: RemoveGuestModal
  },
  [ModalType.SelectGratuity]: {
    ModalComponent: SelectGratuityModal
  },
  [ModalType.SpecialOccasion]: {
    ModalComponent: SpecialOccasionModal
  },
  [ModalType.SpecialRequest]: {
    ModalComponent: SpecialRequestModal
  },
  [ModalType.UpdateCard]: {
    ModalComponent: UpdateCardModalV2
  },
  [ModalType.ViewGuests]: {
    ModalComponent: ViewGuestsModal
  },
  [ModalType.ViewSplitBill]: {
    ModalComponent: ViewSplitBillModal
  },
  [ModalType.WaitlistEstimate]: {
    ModalComponent: WaitlistEstimateModal
  }
};

export const ModalContainer = () => {
  const { isOpen, currentModal, close } = useModal();
  const { ModalComponent = null, wrapInContainer = true } = currentModal
    ? MODAL_COMPONENT_MAP[currentModal]
    : {};

  if (!isOpen || ModalComponent == null) {
    return null;
  }

  if (wrapInContainer) {
    return (
      <BaseDrawerContainer isOpen={isOpen} onClose={close}>
        <ModalComponent />
      </BaseDrawerContainer>
    );
  }

  return (
    <ModalComponent isOpen={isOpen} onClose={close} dataTestId={currentModal} />
  );
};
